import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Tab, Tabs } from "@material-ui/core"
import "./MenuList.module.scss"
import "./MenuTabs.scss"
import locations from "../../data/locations"
import universalMenuOne from "../../images/menu/universal-menu-1.jpg"
import universalMenuTwo from "../../images/menu/universal-menu-2.jpg"

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
})

function TabPanel(props) {
  const { children, value, index } = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`menu-tabpanel-${index}`}
      aria-labelledby={`menu-tab-${index}`}
    >
      {value === index && <div style={{ margin: "0 auto" }}>{children}</div>}
    </div>
  )
}

export default function MenuTabs(props) {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <section className="menu__page" aria-label="Menu Selections">
      <div className="tabs">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
          aria-label="Restaurant locations menu"
        >
          {locations.map((location, index) => (
            <Tab
              key={location.name}
              label={location.name}
              disableRipple
              id={`menu-tab-${index}`}
              aria-controls={`menu-tabpanel-${index}`}
            />
          ))}
        </Tabs>
      </div>
      <div className="menu__imageContainer">
        {locations.map((location, index) => (
          <TabPanel key={location.name} value={value} index={index}>
            <div className="menu__image">
              <img
                className="image"
                src={universalMenuTwo}
                alt={`Sit Lo Saigon ${location.name} Menu Page 1`}
              />
              <img
                className="image"
                src={universalMenuOne}
                alt={`Sit Lo Saigon ${location.name} Menu Page 2`}
              />
            </div>
          </TabPanel>
        ))}
      </div>
    </section>
  )
}
